import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

export default function Edithgoal() {
  const [detailsGoals, setDetailsGoals] = useState([]);
  const [milestones, setMilestones] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = useState([]);
  const [selectStartDate, setSelectStartDate] = useState(new Date())
  const [selectEndDate, setSelectEndDate] = useState(new Date())
  const [listProjectArray, setListProjectArray] = useState([]);
  const [linkedTaskID, setLinkedTaskId] = useState('')
  const [linkOptionType, setLinkOptionType] = useState('');
  const [linkedProjectID, setLinkedProjectId] = useState('')
  const [listProjectTaskArray, setListProjectTaskArrayy] = useState([]);
  const [deletedMilestones, setDeletedMilestones] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [goalData, setGoalData] = useState({
    title: '',
    description: '',
    category: 'Sales',
    priority: 'Mid',
    status: 'Not Started',
    progress: 0,
  });
  const navigate = useNavigate();
  useEffect(() => {
    const goalId = localStorage.getItem('goal_id');
    const userId = localStorage.getItem('member_id');
    const companyId = localStorage.getItem('mem_company_id');
    const userType = localStorage.getItem('user_position');
    fetch('getGoalFullDetails.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({
        goal_id: goalId,
        user_id: userId,
        company_id: companyId,
        user_type: userType
      })
    })
      .then(response => response.json()) // auto parses JSON
      .then(res => {
        console.log(res);

        if (res.success) {

          setDetailsGoals(res.goal);
          setMilestones(res.milestones || []);
          setExistingFiles(res.files);

          setGoalData({
            title: res.goal.title || '',
            description: res.goal.description || '',
            category: res.goal.category || 'Sales',
            priority: res.goal.priority || 'Mid',
            status: res.goal.status || 'Not Started',
            progress: res.goal.progress || 0,
          });

          if (res.goal.start_date) {
            setSelectStartDate(new Date(res.goal.start_date));
            setSelectEndDate(new Date(res.goal.end_date));
          }

        } else {
          showAlert(res.message);
        }
      })
      .catch(error => {
        console.error("Fetch Error:", error);
      });
  }, [])

  useEffect(() => {
    var company_id = localStorage.getItem('mem_company_id');
    var obj = {
      companyId: company_id
    };

    fetch('getAllProjects.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(obj)
    })
      .then(response => response.json()) // ✅ important
      .then(parsedResult => {
        try {
          if (Array.isArray(parsedResult) && parsedResult.length > 0) {
            setListProjectArray(parsedResult);
          } else {
            showAlert('No active projects found for your company.');
            setListProjectArray([]);
          }
        } catch (e) {
          console.error("Processing error:", e);
          showAlert('Failed to load project data.');
          setListProjectArray([]);
        }
      })
      .catch(error => {
        console.error("Fetch Error:", error);
        showAlert('Server error while fetching projects.');
        setListProjectArray([]);
      });
  }, [])

  const handleGoalChange = (e) => {
    setGoalData({
      ...goalData,
      [e.target.name]: e.target.value
    });
  };

  const handleStartDateChange = (date) => {
    setSelectStartDate(date);
  }

  const handleEndDateChange = (date) => {
    setSelectEndDate(date);
  }

  function showAlert(msg) {
    $('#alertpop').css('display', 'block');
    $('#alert_text').text(msg);
  }

  function closeAlert() {
    $('#alertpop').css('display', 'none');
    $('#alert_text').text('');
  }

  function showOptionAlert(msg) {
    $('#optionalertpop').css('display', 'block');
    $('#optionalert_text').text(msg);
  }
  function closeOptionAlert() {
    $('#optionalertpop').css('display', 'none');
    $('#alert_text').text('');
  }

  function setLinkOption(opt) {
    setLinkOptionType(opt)
    if (opt == 'project') {
      showOptionAlert('If you have any previous task link that will be remove by this action')
    } else if (opt == 'task') {
      showOptionAlert('If you have any previous project link that will be remove by this action')
    }
  }

  function goodToGo() {
    closeOptionAlert()
    if (linkOptionType == 'project') {
      setLinkedTaskId('');
      $('#optionproject').css('display', 'block');
    } else if (linkOptionType == 'task') {
      setLinkedProjectId('');
      $('#optionproject').css('display', 'block');
      $('#optiontask').css('display', 'block');
    }
  }

  const selectProjectId = (e) => {
    var trgval = e.target.value;
    if (linkOptionType == 'project') {
      setLinkedProjectId(trgval);
    } else if (linkOptionType == 'task') {
      getTaskListForProject(trgval);
    }

  }

  function getTaskListForProject(proid) {
    var obj = {
      pro_id: proid
    }

    $.ajax({
      type: 'POST',
      url: 'getAllProjectTasks.php',
      data: obj,
      cache: false,
      success: function (result) {
        var res = result;
        if (res !== 'fail' && res !== '') {
          var arr = res;
          setListProjectTaskArrayy(arr);
        } else {
          showAlert('Cannot found any task for this project.');
          $('#norecord').css('display', 'block');
        }
      },
    });
  }

  const selectTaskId = (e) => {
    var trgval = e.target.value;
    setLinkedTaskId(trgval)
  }

  const updateGoal = async () => {
    const goalId = localStorage.getItem('goal_id');
    const com_id = localStorage.getItem('mem_company_id');
    const userId = localStorage.getItem('member_id');
    if (!userId) {
      alert("Login expired");
      return;
    }
    const formData = new FormData();
    formData.append("company_id", com_id);
    formData.append("project_id", linkedProjectID);
    formData.append("task_id", linkedTaskID);
    formData.append("goal", JSON.stringify({
      ...goalData,
      start_date: selectStartDate.toISOString().split('T')[0],
      end_date: selectEndDate.toISOString().split('T')[0],
      id: goalId
    }));

    try {

      const res = await fetch("updateGoals.php", {
        method: "POST",
        body: formData
      });

      const text = await res.text();
      console.log("RAW RESPONSE:", text);

      const data = JSON.parse(text);

      if (data.success) {

        showAlert("Goal successfully updated");


        //navigate('/goal_details');

      } else {
        showAlert(data.message);
      }

    } catch (err) {
      console.error(err);
      showAlert("Server Error");
    }

  }

  const updateMilestone = (index, field, value) => {
    const updated = [...milestones];
    updated[index][field] = value;
    setMilestones(updated);
  };

  const addMilestone = () => {
    setMilestones([
      ...milestones,
      {
        id: null,
        title: '',
        due_date: '',
        status: 'pending',
        completed_at: '',
        description: '',
        goal_id: '',
        isNew: true
      }
    ]);
  };

  const removeMilestone = (index, milestoneId) => {
    if (milestoneId) {
      setDeletedMilestones([...deletedMilestones, milestoneId]);
    }

    const updated = milestones.filter((_, i) => i !== index);
    setMilestones(updated);
  };


  const saveMilestones = async () => {
    const goalId = localStorage.getItem('goal_id');

    const payload = {
      goal_id: goalId,
      milestones: milestones,
      deleted: deletedMilestones
    };

    const res = await fetch('updateGoalMilestones.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    const text = await res.text();
    console.log("RAW RESPONSE:", text);
    const data = JSON.parse(text);

    if (data.success) {
      showAlert("Milestones updated successfully");
      setDeletedMilestones([]);
    } else {
      showAlert(data.message);
    }
  };

  const saveGoalFiles = async () => {
    const goalId = localStorage.getItem('goal_id');
    const userId = localStorage.getItem('member_id');
    const formData = new FormData();
    formData.append("goal_id", goalId);
    formData.append("user_id", userId);
    formData.append("deleted", JSON.stringify(deletedFiles));

    newFiles.forEach((file) => {
      formData.append("files[]", file);
    });

    const res = await fetch("updateGoalFiles.php", {
      method: "POST",
      body: formData
    });

    const data = await res.json();

    if (!data.success) {
      showAlert(data.message);
    } else {
      showAlert('Files updated successfully');
    }
  };


  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);

    setNewFiles(prev => [...prev, ...files]);

    const previewUrls = files.map(file => ({
      name: file.name,
      url: URL.createObjectURL(file),
      type: file.type
    }));

    setPreviews(prev => [...prev, ...previewUrls]);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div>
      <Topbar toggleSidebar={toggleSidebar} />
      <Sidebar_component sidebarOpen={sidebarOpen} />
      <div className='vl_dsh_bodypart'>
        <div className='vl_alltab'>
          <h2 className='bigfonttabs'>Edit Goals</h2>
          <Link className='pull_right add_new_pro' to="/goal_details">View Goal Details</Link>
        </div>
        <section className='vl_dsh_bodypart_section'>
          <div className='vl_dsh_container'>
            <div className='vl_dsh_one_row'>
              <div className='vl_dsh_one_half'>
                <div className='inforow'>
                  <p className='titlebox'>Goal Title:</p>
                  <input type='text' id="title" name="title" onChange={handleGoalChange} value={goalData.title} />
                </div>

                <div className='inforow'>
                  <p className='titlebox'>Goal Description:</p>
                  <textarea id="description" name="description" onChange={handleGoalChange} value={goalData.description}></textarea>
                </div>



                <div className='inforow'>
                  <p className='titlebox'>Goal Category:</p>
                  <select id="category" name="category" onChange={handleGoalChange} value={goalData.category}>
                    <option value="Sales">Sales</option>
                    <option value="Development">Development</option>
                    <option value="Marketing">Marketing</option>
                    <option value="Finance">Finance</option>
                    <option value="Personal">Personal</option>
                    <option value="Operations">Operations</option>
                  </select>
                </div>

                <div className='inforow'>
                  <p className='titlebox'>Goal Priority:</p>
                  <select id="priority" name="priority" onChange={handleGoalChange} value={goalData.priority}>
                    <option value="Low">Low</option>
                    <option value="Mid">Mid</option>
                    <option value="High">High</option>
                  </select>
                </div>
              </div>
              <div className='vl_dsh_one_half'>
                <div className='inforow'>
                  <p className='titlebox'>Goal Status:</p>
                  <select id="status" name="status" onChange={handleGoalChange} value={goalData.status}>
                    <option value="not_started">Not Started</option>
                    <option value="in_progress">In Progress</option>
                    <option value="on_hold">On Hold</option>
                    <option value="completed">Completed</option>
                  </select>
                </div>

                <div className='inforow'>
                  <p className='titlebox'>Start Date:</p>
                  <DatePicker
                    selected={selectStartDate}
                    onChange={handleStartDateChange}
                    dateFormat="yyyy-MM-dd"
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"

                    yearDropdownItemNumber={50}
                    scrollableYearDropdown
                  />
                </div>
                <div className='inforow'>
                  <p className='titlebox'>End Date:</p>
                  <DatePicker
                    selected={selectEndDate}
                    onChange={handleEndDateChange}
                    dateFormat="yyyy-MM-dd"
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                    yearDropdownItemNumber={50}
                    scrollableYearDropdown
                  />
                </div>

                <div className='inforow'>
                  <p className='titlebox'>Goal Progress:</p>
                  <input type="range" min='0' max="100" name="progress" id="progress" value={goalData.progress} onChange={handleGoalChange} />
                  <span className='ml-10'>{goalData.progress}%</span>
                </div>
                <div className="inforow">
                  <p className="titlebox">Linked Project:</p>
                  <p className="detailbox">
                    {detailsGoals.project_name || "Not Linked"}
                  </p><button className='small_button ml-10' onClick={() => { setLinkOption('project') }}>Add Link</button>
                </div>

                <div className="inforow">
                  <p className="titlebox">Linked Task:</p>
                  <p className="detailbox">
                    {detailsGoals.task_name || "Not Linked"}
                  </p><button className='small_button ml-10' onClick={() => { setLinkOption('task') }}>Add Link</button>
                </div>
                <div className='vl_dsh_one_half mt-15 nodisplay linkedoptions' id="optionproject">
                  <label>Select a project</label>
                  <select name="selectproject" onChange={selectProjectId}>
                    <option value="">Select a Project</option>
                    {listProjectArray.map((project) => (
                      <option key={project.primary_key} value={project.primary_key}>
                        {project.pro_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className='vl_dsh_one_half mt-15 nodisplay linkedoptions' id="optiontask">

                  <label>Select a Task</label>
                  <select name="selecttask" onChange={selectTaskId}>
                    <option value="">Select a task</option>
                    {listProjectTaskArray.map((task) => (
                      <option key={task.primary_key} value={task.primary_key}>
                        {task.taskname}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className='vl_dsh_one_full vl_dsh_buttonholder'>
                <button className='pull_right' onClick={updateGoal}>Update</button>
              </div>
            </div>
          </div>
          <div className='vl_dsh_container'>
            <div className='vl_dsh_one_row'>
              <div className='vl_dsh_one_half mt-50 milestones'>
                <h2>Milestones</h2>
                {milestones.length === 0 && <p>No milestones</p>}

                {milestones.map((ms, index) => (
                  <div key={index} className="milestone-row">
                    <div className="inforow">
                      <p className='titlebox'>Milestone title:</p>
                      <input
                        type="text"
                        placeholder="Milestone title"
                        value={ms.title}
                        onChange={(e) => updateMilestone(index, 'title', e.target.value)}
                      />
                    </div>
                    <div className="inforow">
                      <p className='titlebox'>Milestone Description:</p>
                      <textarea placeholder='Milestone Description' onChange={(e) => updateMilestone(index, 'description', e.target.value)} value={ms.description}></textarea>
                    </div>
                    <div className="inforow">
                      <p className='titlebox pt-21'>Milestone Due Date:</p>
                      <input
                        type="date"
                        value={ms.due_date}
                        onChange={(e) => updateMilestone(index, 'due_date', e.target.value)}
                      />
                    </div>
                    <div className="inforow">
                      <p className='titlebox'>Milestone Status:</p>
                      <select
                        value={ms.status}
                        onChange={(e) => updateMilestone(index, 'status', e.target.value)}
                      >
                        <option value="pending">Pending</option>
                        <option value="completed">Completed</option>
                      </select>
                    </div>
                    <div className="inforow">
                      <button
                        className="edit_subbutton delbutton"
                        onClick={() => removeMilestone(index, ms.id)}
                      ><i class="ri-delete-bin-3-fill"></i>
                        Delete
                      </button>

                    </div>
                  </div>
                ))}

              </div>
            </div>
            <div className='vl_dsh_one_row mt-30'>
              <div className='vl_dsh_one_full'>
                <div className='vl_dsh_buttonholder'>
                  <button className='pull_right mr-10' onClick={saveMilestones}>Update Milestones</button>
                  <button className="edit_subbutton addbtn pull_right" onClick={addMilestone}>Add Milestone</button>
                </div>
              </div>
            </div>
          </div>
          <div className='vl_dsh_container'>
            <div className='vl_dsh_one_row'>
              <div className='vl_dsh_one_half mt-50 milestones'>
                <h2>Files</h2>
                <div className="inforow">
                  <p className="titlebox">Upload New Files</p>
                  <input
                    type="file"
                    multiple
                    accept="image/*,.pdf,.doc,.docx"
                    onChange={handleFileSelect}
                  />

                </div>
                <div className="preview_grid">
                  {previews.map((file, i) => (
                    <div key={i} className="preview_item">
                      {file.type.startsWith("image/") ? (
                        <img src={file.url} alt={file.name} />
                      ) : (
                        <p>{file.name}</p>
                      )}
                    </div>
                  ))}
                </div>

                <div className='mt-30 fullwidth pull_left'>&nbsp;</div>
                <div className="inforow">
                  <p className="titlebox">Attached Files</p>

                  {existingFiles.length === 0 && <p>No files uploaded</p>}

                  {existingFiles.map((file) => (
                    <div key={file.id} className="file_row">
                      <div className='inforow'>
                        <a href={file.file_link} target="_blank" rel="noreferrer">
                          {file.file_name}
                        </a>

                        <button
                          className="small_button ml-10 danger"
                          onClick={() => {
                            setDeletedFiles([...deletedFiles, file.id]);
                            setExistingFiles(existingFiles.filter(f => f.id !== file.id));
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  ))}
                </div>


              </div>
              <div className='one_half'>
                {newFiles.length > 0 && (
                  <div className="inforow">
                    <p className="titlebox">New Files</p>
                    {newFiles.map((file, i) => (
                      <p key={i}>{file.name}</p>
                    ))}
                  </div>
                )}

              </div>
            </div>
          </div>
          <div className='vl_dsh_one_row mt-30'>
            <div className='vl_dsh_one_full'>
              <div className='vl_dsh_buttonholder'>
                <button className='pull_right mr-10' onClick={saveGoalFiles}>Update Files</button>
              </div>
            </div>
          </div>
        </section>
      </div >
      <div className='vl_dsh_popup' id="alertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="alert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeAlert}>Okay</button>
          </div>
        </div>
      </div>
      <div className='vl_dsh_popup' id="optionalertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="optionalert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={goodToGo}>Okay</button>
            <button className='ml-10' onClick={closeOptionAlert}>Cancel</button>
          </div>
        </div>
      </div>
    </div >
  )
}
